import * as React from 'react';
import { rng } from '../../amorg-common';
import CreateUserForm, { getEmptyUserData, UserData } from '../users/_components/CreateUserForm';
import { MessageCardVariants } from '../../designSystem/MessageCard';
import { H1 } from '../../designSystem/typography/Heading';
import { SingleColumnLayout } from '../_layouts/SingleColumnLayout';
import { requestUserCreation } from '../../api/userClientApi';
import { fieldValidation } from '../../amorg-common';
import { PublicPageWrapper } from '../_pageWrappers/PublicPageWrapper';

export default function RequestCreateUserPage (): JSX.Element
{
    const [userData, setUserData] = React.useState<UserData>(getEmptyUserData());
    const [result, setResult] = React.useState<
        { didSubmit: false; } |
        { didSubmit: true, success: true; } |
        { didSubmit: true, success: false, errorMessage: string; }
    >({ didSubmit: false });

    async function handleSubmit ()
    {
        const isValid =
            fieldValidation.site.id(userData.siteId) &&
            fieldValidation.user.firstname(userData.firstname) &&
            fieldValidation.user.middlename(userData.middlename) &&
            fieldValidation.user.lastname(userData.lastname) &&
            fieldValidation.user.email(userData.email) &&
            fieldValidation.user.password(userData.password) &&
            userData.passwordRepeated === userData.password;

        if (isValid)
        {
            const result = await requestUserCreation(userData.siteId, rng.getRandomId('u_'), userData.firstname, userData.middlename, userData.lastname, userData.email, userData.password);
            if (result.isSuccess)
            {
                setResult({ didSubmit: true, success: true });
            }
            else
            {
                if (result.errorMessage === 'requestUserCreation_email_in_use')
                    setResult({ didSubmit: true, success: false, errorMessage: 'Email addressen er allerede i brug.' });
                else
                    setResult({ didSubmit: true, success: false, errorMessage: 'Kunne ikke oprette brugeren.' });
            }
        }
        else
            setResult({ didSubmit: true, success: false, errorMessage: 'Kan ikke oprette brugere da der er fejl i et eller flere felter.' });
    }



    let message: { type: MessageCardVariants, text: string; } | undefined = undefined;
    if (result.didSubmit)
    {
        if (result.success === true)
            message = { type: 'success', text: 'Brugeren er klar til oprettelse. Du vil om kort tid modtage en e-mail med instruktioner i hvordan du gennemfører oprettelsen.' };
        else
            message = { type: 'error', text: result.errorMessage };
    }

    return (

        <PublicPageWrapper>
                <SingleColumnLayout narrow>
                    <H1>Opret bruger</H1>
                    <CreateUserForm
                        userData={userData}
                        message={message}
                        displaySite={true}
                        disableCreateButton={result.didSubmit && result.success}
                        disableValidation={!result.didSubmit}
                        onUserDataChange={(data) => setUserData(data)}
                        onCreateUser={handleSubmit}

                    />
                </SingleColumnLayout>

        </PublicPageWrapper>
    );
}